// fetchSmartfillSaga.js
import { takeLatest } from 'redux-saga/effects';
import { get } from '@airasia-common/libraries/http/hotelRequest';
import { toHotelAPILanguage } from '../../hotel/ApiParams';
import genericApiSaga from '../../sagas/genericApiSaga';
import { actionCreators, types } from './smartfill.meta';

export function* fetchSmartfill(payload) {
  if (payload?.locationId && payload?.languageId) {
    yield genericApiSaga({
      completed: actionCreators.fetchSmartfillData,
      failed: actionCreators.fetchSmartfillDataFailed,
      gatewayCall: () =>
        get(`/smartfill/v3/smartfill/${payload?.locationId}`, {
          language: toHotelAPILanguage(payload?.languageId),
        }),
    });
  }
}

export default function* createSmartFillSaga() {
  yield takeLatest(types.FETCH_SMARTFILL, fetchSmartfill);
}
